/**
 * The product logo «ПРОСТО Таск» — brandbook v1 «Открыто», DS `Logo` (product).
 *
 * The mark is an open door: a frame, a leaf swung inward, the light of the
 * doorway in Свет and the light it throws on the floor. Colours are tokens, so
 * the mark follows the theme with the rest of the app.
 */

import { useId } from "react";

export function LogoMark({ size = 32 }: { size?: number }) {
  const floor = useId();
  return (
    <svg width={size} height={size} viewBox="0 0 240 240" aria-hidden="true" className="shrink-0">
      <defs>
        <linearGradient id={floor} x1={0} y1={0} x2={0} y2={1}>
          <stop offset={0} stopColor="var(--p-accent)" stopOpacity={0.7} />
          <stop offset={1} stopColor="var(--p-accent)" stopOpacity={0} />
        </linearGradient>
      </defs>
      <polygon points="74,196 166,196 214,232 26,232" fill={`url(#${floor})`} />
      <rect x={74} y={62} width={92} height={134} fill="var(--p-accent)" />
      <polygon points="74,62 102,76 102,186 74,196" fill="var(--p-mark-leaf)" opacity={0.9} />
      <path d="M60 196 V48 H180 V196" fill="none" stroke="var(--p-mark-frame)" strokeWidth={28} />
    </svg>
  );
}

/** Mark plus «ПРОСТО» over the product name, as on the canvas header. */
export function ProductLogo({ product = "Таск", size = 32, markBelowXl = false }: { product?: string; size?: number; markBelowXl?: boolean }) {
  return (
    <span className="inline-flex items-center text-p-text" style={{ gap: Math.round(size * 0.28) }}>
      <LogoMark size={size} />
      {/* The compact sidebar (1024–1279 px) has room for the mark only. */}
      <span className={markBelowXl ? "hidden flex-col gap-1 leading-none xl:inline-flex" : "inline-flex flex-col gap-1 leading-none"}>
        <span className="text-[12px] font-semibold leading-4 tracking-[.08em] text-p-text-muted">ПРОСТО</span>
        <span className="font-extrabold leading-none tracking-[-0.02em]" style={{ fontSize: Math.round(size * 0.62) }}>
          {product}
        </span>
      </span>
    </span>
  );
}
